import React, { FC } from 'react'
import { ColorLegend } from 'models/legend'
import { Flex } from 'components/Flex'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import styles from './Color.module.scss'

type ColorProps = {
  data: ColorLegend
}

export const Color: FC<ColorProps> = ({ data }) => {
  const background = `linear-gradient(90deg, ${data.colors.join(', ')})`

  return (
    <Stack space="small">
      <div className={styles.gradient} style={{ background }} />
      <Flex justify="between" align="center">
        <Text weight="strong" size="small">
          {data.min}
        </Text>
        <Text weight="strong" size="small">
          {data.max}
        </Text>
      </Flex>
    </Stack>
  )
}

Color.displayName = 'Color'
